import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ElectronicPrescriptionsListBody from "components/PatientManagement/ElectronicPrescriptions/ElectronicPrescriptionsListBody";

export default function ElectronicPrescriptions() {
  useEffect(() => {
    document.title = "ElectronicPrescriptions";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <ElectronicPrescriptionsListBody />
    </main>
  );
}
